import { post } from "@/utils/utils";

const live = {
  state: {
    goodsCategoryList: {}
  },
  mutations: {
    QUERY_LIVE_LIST() {},
    SYNC_LIVE_ROOM() {},
    GET_REPLAY_LIST() {},
    EDIT_LIVE_SHOW_OR_HIDE() {},
    DELETE_LIVE_ROOM() {},
    SET_ROOM_SHOW_STATUS() {},
    QUERY_STORE_CONFIG_LIVE() {},
    RECOMMEND_RANKING_PAGE() {},
    ADD_STORE_CONFIG_LIVE() {},
    EDIT_STORE_CONFIG_LIVE() {},
    QUERY_LIVE_PLAN_LIST() {},
    ADD_LIVE_PLAN() {},
    EDIT_LIVE_PLAN() {},
    QUERY_BY_ID_LIVE_PLAN() {},
    LIVE_SHOW_WXSHOP_SPU_ID_BY_PLAN_ID() {},
    SET_LIVE_SHOW_WXSHOP_SPU_ID_BY_ID() {},
    REMOVE_BY_MODEL() {},
    SKU_SPEC_DETAIL() {},
    SPU_DETAIL() {},
  },
  actions: {
    queryLiveList({ commit }, params) {
      return post({
        commit,
        url: `/back/live/list`,
        name: "QUERY_LIVE_LIST",
        params
      });
    },
    syncLiveRoom({ commit }, params) {
      return post({
        commit,
        url: `/back/live/pull`,
        name: "SYNC_LIVE_ROOM",
        params
      });
    },
    deleteLiveRoom({ commit }, params) {
      return post({
        commit,
        url: `/back/live/delete`,
        name: "DELETE_LIVE_ROOM",
        params
      });
    },
    setRoomShowStatus({ commit }, params) {
      return post({
        commit,
        url: `/back/live/setRoomShowStatus`,
        name: "SET_ROOM_SHOW_STATUS",
        params
      });
    },
    getReplayList({ commit }, params) {
      return post({
        commit,
        url: `/back/live/get_replay_list`,
        name: "GET_REPLAY_LIST",
        params
      });
    },
    editLiveShowOrHide({ commit }, params) {
      return post({
        commit,
        url: `/back/live/edit`,
        name: "EDIT_LIVE_SHOW_OR_HIDE",
        params
      });
    },
    queryStoreConfigLive({ commit }, params) {
      return post({
        commit,
        url: `/sys/common/query_store_config`,
        name: "QUERY_STORE_CONFIG_LIVE",
        params
      });
    },
    recommendRankingPage({ commit }, params) {
      return post({
        commit,
        url: `/back/live/recommendRankingPage`,
        name: "RECOMMEND_RANKING_PAGE",
        params
      });
    },
    addStoreConfigLive({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/add`,
        name: "ADD_STORE_CONFIG_LIVE",
        params
      });
    },
    editStoreConfigLive({ commit }, params) {
      return post({
        commit,
        url: `/sys/config/edit`,
        name: "EDIT_STORE_CONFIG_LIVE",
        params
      });
    },
    queryLivePlanList({ commit }, params) {
      return post({
        commit,
        url: `/live/storeLivePlanInfo/queryPageList`,
        name: "QUERY_LIVE_PLAN_LIST",
        params
      });
    },
    addLivePlan({ commit }, params) {
      return post({
        commit,
        url: `/live/storeLivePlanInfo/add`,
        name: "ADD_LIVE_PLAN",
        params
      });
    },
    editLivePlan({ commit }, params) {
      return post({
        commit,
        url: `/live/storeLivePlanInfo/edit`,
        name: "EDIT_LIVE_PLAN",
        params
      });
    },    
    queryByIdLivePlan({ commit }, params) {
      return post({
        commit,
        url: `/live/storeLivePlanInfo/queryById`,
        name: "QUERY_BY_ID_LIVE_PLAN",
        params
      });
    },
    liveShowWxshopSpuIdByPlanId({ commit }, params) {
      return post({
        commit,
        url: `/provider/promotion/micro/live/storeLivePlanInfo/liveShowWxshopSpuIdByPlanId`,
        name: "LIVE_SHOW_WXSHOP_SPU_ID_BY_PLAN_ID",
        params
      });
    },
    skuSpecDetail({ commit }, params) {
      return post({
        commit,
        url: `/mobile_mall/sku_spec_detail`,
        name: "SKU_SPEC_DETAIL",
        params
      });
    },
    spuDetail({ commit }, params) {
      return post({
        commit,
        url: `/mobile_mall/spu_detail`,
        name: "SPU_DETAIL",
        params
      });
    },
    setLiveShowWxshopSpuIdById({ commit }, params) {
      return post({
        commit,
        url: `/provider/promotion/micro/live/storeLivePlanInfo/setLiveShowWxshopSpuIdById`,
        name: "SET_LIVE_SHOW_WXSHOP_SPU_ID_BY_ID",
        params
      });
    },
    removeByModel({ commit }, params) {
      return post({
        commit,
        url: `/live/storeLivePlanGoodsRel/removeByModel`,
        name: "REMOVE_BY_MODEL",
        params
      });
    },
  }
};

export default live;
